import BaseResource from './index'
import AgreementResource from '../resources/agreement'
import UnionLocalResource from '../resources/unionLocal'
import UnionJurisdictionResource from '../resources/unionJurisdiction'

export default class AgreementUnionMxResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/agreementunionmx'
    static related() {
        return {
            union_local_id: UnionLocalResource,
            agreement_id: AgreementResource,
            jurisdiction_id: UnionJurisdictionResource,
        }
    }
}
